import {
    USER_LOGGED,
} from '../types';


const initialState = {
    logged: 0,
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case USER_LOGGED:
            return {
                ...state,
                logged: action.payload,
            };
        default:
            return state;
    }
};

export default userReducer;
